import { useRef, useEffect } from "react";
import useRegistrationContext from "../../../../hooks/useRegistrationContext";
import { useQuery } from "react-query";
import { getTitles } from "../../../../api/apiServices";
import toast, { Toaster } from "react-hot-toast";
import ProfilePictureLoader from "./ProfilePictureLoader";

const PersonalInformation = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const inputRef = useRef();
	const dobRef = useRef();

	const { data, handleChange, regularData } = useRegistrationContext();

	const { data: titles } = useQuery("titles", () => getTitles());

	const handleDOB = (e) => {
		const dateOfBirth = new Date(e.target.value);
		const today = new Date();
		const ageDifference = today.getTime() - dateOfBirth.getTime();
		const daysOld = Math.floor(ageDifference / (1000 * 60 * 60 * 24));
		const memberAge = Number((daysOld / 365).toFixed(0));
		const acceptableAge = 18;

		if (memberAge < acceptableAge) {
			toast.error(
				`Member cannot be less than ${acceptableAge} years. Check the date of birth again`,
				{
					duration: 5000,
					className: "toast-message",
				}
			);
			dobRef.current.focus();
			return false;
		}
		return true;
	};

	const content = (
		<>
			<fieldset className="col-sm-12">
				<legend>UPLOAD PROFILE PICTURE </legend>
				<div className="form-group row">
					<label htmlFor="photo" className="col-sm-2 label-text">
						Passport Photo<span>&nbsp;&nbsp;*</span>
					</label>
					<ProfilePictureLoader name={"personalProfilePicture"} />
				</div>
				<hr />
			</fieldset>
			<fieldset className="col-sm-12">
				<legend>PERSONAL INFORMATION</legend>
				<fieldset className="col-sm-6">
					<div className="form-group row">
						<label htmlFor="title" className="col-sm-4 label-text">
							Title<span>&nbsp;&nbsp;*</span>
						</label>

						<div className="col-sm-8">
							<select
								type="text"
								id="title"
								autoComplete="off"
								style={{
									textTransform: "uppercase",
								}}
								onChange={handleChange}
								value={data.personalTitle}
								required
								name="personalTitle"
								className="form-control"
							>
								<option value=""></option>
								{titles?.map((item, index) => (
									<option value={item.title} key={index}>
										{item.title}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="last_name"
							className="col-sm-4 label-text"
						>
							Last Name<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-8">
							<input
								ref={inputRef}
								type="text"
								id="last_name"
								autoComplete="off"
								onChange={handleChange}
								required
								style={{
									textTransform: "uppercase",
								}}
								value={data.personalLastname}
								name="personalLastname"
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="first_name"
							className="col-sm-4 label-text"
						>
							First Name<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-8">
							<input
								ref={inputRef}
								type="text"
								id="first_name"
								autoComplete="off"
								onChange={handleChange}
								required
								style={{
									textTransform: "uppercase",
								}}
								value={data.personalFirstname}
								name="personalFirstname"
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="middle_name"
							className="col-sm-4 label-text"
						>
							Middle Name
						</label>
						<div className="col-sm-8">
							<input
								type="text"
								id="middle_name"
								autoComplete="off"
								onChange={handleChange}
								style={{
									textTransform: "uppercase",
								}}
								value={data.personalMiddleName}
								name="personalMiddleName"
								className="form-control"
							/>
						</div>
					</div>
				</fieldset>
				<fieldset className="col-sm-6">
					<div className="form-group row">
						<label
							htmlFor="date_of_birth"
							className="col-sm-4 label-text"
						>
							Date of Birth<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-8">
							<input
								type="date"
								ref={dobRef}
								id="date_of_birth"
								autoComplete="off"
								style={{
									textTransform: "uppercase",
								}}
								onChange={handleChange}
								onBlur={handleDOB}
								required
								value={data.personalDateOfBirth}
								name="personalDateOfBirth"
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label className="col-sm-4 label-text">
							Gender<span>&nbsp;&nbsp;*</span>
						</label>
						{regularData.genderData.map((item) => (
							<div className="col-sm-4" key={item.id}>
								<label htmlFor={`gender${item.id}`}>
									<input
										type="checkbox"
										id={`gender${item.id}`}
										name="personalGender"
										checked={
											data.personalGender === item.value
										}
										value={item.value}
										onChange={handleChange}
									/>
								</label>
								<span className="checkbox-label">
									{item.label}
								</span>
							</div>
						))}
					</div>
					<div className="form-group row">
						<label className="col-sm-12 label-text">
							Marital Status<span>&nbsp;&nbsp;*</span>
						</label>
					</div>
					<div className="form-group row">
						{regularData.maritalStatus.map((item) => (
							<div className="col-sm-4" key={item.id}>
								<label htmlFor={`marital_status${item.id}`}>
									<input
										type="checkbox"
										id={`marital_status${item.id}`}
										name="personalMaritalStatus"
										checked={
											data.personalMaritalStatus ===
											item.value
										}
										value={item.value}
										onChange={handleChange}
									/>
								</label>
								<span className="checkbox-label">
									{item.label}
								</span>
							</div>
						))}
					</div>
				</fieldset>
			</fieldset>
		</>
	);
	<Toaster toastOptions={{ position: "top-center" }} />;
	return content;
};
export default PersonalInformation;
